// import "./Inputfield.scss";
import Inputelement from "features/common/BaseComponents/InputElement/Inputlement";
import formFieldHOC from "../../InputfieldHOC/InputfieldHOC";

export default formFieldHOC(Inputelement);
